import { combineReducers } from '@reduxjs/toolkit';

import { persistReducer } from 'redux-persist';

import { appConfigPersistConfig } from '../persistor/app-config-persist';
import { authPersistConfig } from '../persistor/auth-persist';
import { translationPersistConfig } from '../persistor/translation-persist';
import appConfigReducer from '../slices/app-config';
import authReducer from '../slices/auth';
import breadcrumbReducer from '../slices/breadcrumb';
import coordinationReducer from '../slices/coordination';
import deviceReducer from '../slices/device';
import deviceActivityReducer from '../slices/device-activity';
import dialogReducer from '../slices/dialog';
import dynamicFilterReducer from '../slices/dynamic-filter';
import entityDetailReducer from '../slices/entity-detail';
import roleChangeNotificationReducer from '../slices/role-change-notification';
import shiftManagementReducer from '../slices/shift-management';
import simpleCoordinationReducer from '../slices/simple-coordination';
import stepFormReducer from '../slices/step-form';
import transferReducer from '../slices/transfer';
import translationReducer from '../slices/translation';

export const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authReducer),
    translation: persistReducer(translationPersistConfig, translationReducer),
    dynamicFilter: dynamicFilterReducer,
    breadcrumb: breadcrumbReducer,
    stepForm: stepFormReducer,
    device: deviceReducer,
    deviceActivity: deviceActivityReducer,
    coordination: coordinationReducer,
    transfer: transferReducer,
    entityDetail: entityDetailReducer,
    dialog: dialogReducer,
    simpleCoordination: simpleCoordinationReducer,
    appConfig: persistReducer(appConfigPersistConfig, appConfigReducer),
    roleChangeNotification: roleChangeNotificationReducer,
    shiftManagement: shiftManagementReducer,
});
